import { render } from "./CustomerioBanner.vue?vue&type=template&id=220b0848&scoped=true&ts=true"
import script from "./CustomerioBanner.vue?vue&type=script&lang=ts"
export * from "./CustomerioBanner.vue?vue&type=script&lang=ts"

import "./CustomerioBanner.vue?vue&type=style&index=0&id=220b0848&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220b0848"]])

export default __exports__